export const addAccountsFromGroupToOrganizationBulkActionType = 'addAccountsFromGroupToOrganization';
